import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, ArrowLeft, X, MoreVertical } from 'lucide-react';

interface MobileHeaderProps {
  title?: string;
  showBack?: boolean;
  showMenu?: boolean;
  showClose?: boolean;
  onMenuClick?: () => void;
  onCloseClick?: () => void;
  onBack?: () => void;
  backTo?: string;
  rightAction?: React.ReactNode;
  transparent?: boolean;
}

const MobileHeader: React.FC<MobileHeaderProps> = ({
  title,
  showBack = false,
  showMenu = false,
  showClose = false,
  onMenuClick,
  onCloseClick,
  onBack,
  backTo,
  rightAction,
  transparent = false,
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      // Custom back handler takes priority
      onBack();
    } else if (backTo) {
      // Navigate to a specific route
      navigate(backTo);
    } else if (window.history.length > 2) {
      // There's meaningful history to go back to
      navigate(-1);
    } else {
      // Fallback: go to the brand campaign page (main dashboard)
      navigate('/brand/campaign');
    }
  };

  return (
    <header 
      className="mobile-header"
      style={transparent ? { background: 'transparent', position: 'absolute', width: '100%' } : {}}
    >
      {/* Left Action */}
      <div style={{ width: 40 }}>
        {showBack && (
          <button className="mobile-header-action" onClick={handleBack}>
            <ArrowLeft size={24} />
          </button>
        )}
        {showMenu && (
          <button className="mobile-header-action" onClick={onMenuClick}>
            <Menu size={24} />
          </button>
        )}
        {showClose && (
          <button className="mobile-header-action" onClick={onCloseClick}>
            <X size={24} />
          </button>
        )}
      </div>

      {/* Title */}
      {title && <h1 className="mobile-header-title">{title}</h1>}

      {/* Right Action */}
      <div style={{ width: 40 }}>
        {rightAction}
      </div>
    </header>
  );
};

export default MobileHeader;
